<template>
  <div>
    <select-base
      ref="base"
      v-model="valueInner"
      :disabled="disabled"
      :multiple="multiple"
      :filtros="filtros"
      :label="'Documento'"
      :label-select="'descricao'"
      :require="false"
      :carregar="carregarDocumentos"
      :invalido="invalido"
      @input="enviarParaPai"
    />
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle */
import api from '@/app-modulo/documento/documento/shared/services/api'
import '@core/scss/vue/libs/vue-select.scss'

export default {
  name: 'ModeloSelect',
  components: {
    SelectBase: () => import('@/shared/components/select-base/SelectBase.vue'),
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    invalido: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    departamento: {
      type: Number,
      default: null,
    },
    value: {
      type: Object,
      default: () => { },
    },
    naoRecorrente: {
      type: Boolean,
      default: false,
    },
    ignorarNaoRecorrente: {
      type: Boolean,
      default: false,
    },
    apenasAtivos: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value_: null,
      filtros: [
        {
          colunas: ['Descricao'],
          valor: null,
          soletrado: true,
        },
        {
          colunas: ['Departamento'],
          valor: this.departamento,
        },
        {
          colunas: ['PeriodicidadeDesc'],
          valor: null,
        },
      ],
    }
  },
  computed: {
    valueInner: {
      set(value) {
        this.value_ = value
      },
      get() {
        return this.value_
      },
    },
  },
  watch: {
    departamento(value, oldValue) {
      if (value !== oldValue && value > 0) {
        this.filtros[1].valor = value
        this.value_ = null
        this.$refs.base.carregarItensFiltrados('')
      }
    },
    value(value, oldValue) {
      if (value !== oldValue) {
        this.valueInner = value
      }
    },
  },
  created() {
    this.valueInner = this.value
    if (this.apenasAtivos) {
      this.filtros.push(
        {
          colunas: ['Ativo'],
          valor: true,
        },
      )
    }
  },
  methods: {
    carregarDocumentos(filtros) {
      if ((!this.naoRecorrente && !filtros[2]) || this.ignorarNaoRecorrente) {
        const filtroRecorrente = { colunas: ['PeriodicidadeDesc'], valor: '0' }
        filtros.push(filtroRecorrente)
      }
      return api.getDocumentosResumidos(filtros)
    },
    enviarParaPai() {
      this.$emit('input', this.valueInner)
    },
  },
}
</script>
